//UTILS
import loader from "../../assets/loader/loader.svg";

export default function Loader () {
    return (
        <div className="w-full h-full flex items-center justify-center">
            <img src={loader} alt="loading..." />
        </div>
    )
}